import { DateTime } from "luxon";
import React from "react";

import { OFFSET } from "@src/features/scheduleExperience/constants";
import { ScheduleContent } from "@src/features/scheduleExperience/ScheduleContent";
import { ScheduleProps } from "@src/features/scheduleExperience/types";

export const EndSchedule = ({
  startAtSchedule,
  pauseAtSchedule,
  endAtSchedule,
  experience,
  isLoading,
  setDateTime,
  dateTime,
  timeNow,
  isStartSet,
  disabledReason,
  currMinDateTime,
  setErrors,
}: ScheduleProps) => {
  return (
    <ScheduleContent
      setErrors={setErrors}
      isStartSet={isStartSet}
      isLoading={isLoading}
      label={"Stop"}
      setDateTime={setDateTime}
      dateTime={dateTime}
      experience={experience}
      action={"end"}
      minScheduleTime={
        experience.status === "started"
          ? timeNow
          : currMinDateTime
            ? currMinDateTime.plus({
                minutes: OFFSET,
              })
            : startAtSchedule?.executionTime
              ? DateTime.fromMillis(startAtSchedule.executionTime).plus({
                  minutes: OFFSET,
                })
              : timeNow
      }
      disabledReason={disabledReason}
      pauseAtSchedule={pauseAtSchedule}
      endAtSchedule={endAtSchedule}
      timeNow={timeNow}
    />
  );
};
